/**
 * https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
 *
 * deprecated: document.execCommand('copy') on textarea
 */
export const copyText = (text: string) => {
    navigator.clipboard.writeText(text);
};
